import { useQuery, useMutation } from "react-query";
import queryClient from "../../../service/reactQuery/queryClient";
import { getAllIAsRequest, createIARequest, editIARequest, deleteIARequest, getAllZonesRequest, runIAAgentRequest } from "./request";

export const useFetchIAsAll = () => {
    return useQuery(["UseIAsAll"], getAllIAsRequest);
};

export const useFetchZonesAll = () => {
    return useQuery(["UseZonesAll"], getAllZonesRequest);
};

export const useCreateIAMutation = () => {
    return useMutation(createIARequest, {
        onSuccess: () => {
            queryClient.refetchQueries("UseIAsAll");
        }
    });
};

export const useEditIAMutation = () => {
    return useMutation(editIARequest, {
        onSuccess: () => {
            queryClient.refetchQueries("UseIAsAll");
        }
    });
};

export const useDeleteIAMutation = () => {
    return useMutation(deleteIARequest, {
        onSuccess: () => {
            queryClient.refetchQueries("UseIAsAll");
        }
    });
};

export const useRunIAMutation = () => {
    return useMutation(({ agentId, input, zoneId }) => runIAAgentRequest(agentId, input, zoneId));
};
